<script>
  export let title
</script>

<style>
  .kb-form__header {
    display: flex;
    align-items: center;
    margin: 0 0 20px 0;
    font-size: 18px;
  }
</style>

<div class="$style.kb-form__header">
  <slot />
  <div class="$style.header__title">{title}</div>
</div>
